/* Navigation only. Checkout and tracking are owned by separate modules. */
/* upstack-remediation:2026-09-26 */
(() => {
  'use strict';
  if (window.UnchemedNavigation) return;
  const mobile = matchMedia('(max-width: 991px)');
  const menuPreloads = new WeakMap();
  let closeActive = () => {};
  function hydrateMenuImages(menu) {
    const preloads = [];
    menu.querySelectorAll('img').forEach((img, index) => {
      img.loading = 'eager';
      img.decoding = 'async';
      img.fetchPriority = index < 7 ? 'high' : 'auto';
      const src = img.currentSrc || img.src;
      if (src) {
        img.src = src;
        img.decode?.().catch(() => {});
        if (!img.complete) {
          const preload = new Image();
          preload.decoding = 'async';
          preload.fetchPriority = img.fetchPriority;
          preload.onload = () => img.decode?.().catch(() => {});
          preload.src = src;
          preloads.push(preload);
        }
      }
    });
    menuPreloads.set(menu, preloads);
  }
  function scheduleMenuImages(menu) {
    const run = () => { if (mobile.matches) hydrateMenuImages(menu); };
    if (document.readyState === 'complete') setTimeout(run, 200);
    else window.addEventListener('load', () => setTimeout(run, 200), {once:true});
  }
  function init(root = document) {
    const header = root.querySelector('[data-unc-navigation]');
    if (!header || header.dataset.navigationBound) return;
    header.dataset.navigationBound = 'true';
    const menu = header.querySelector('#unc-mobile-menu');
    const toggle = header.querySelector('.unc-menu-toggle');
    const backdrop = header.querySelector('.unc-menu-backdrop');
    const desktop = header.querySelector('.unc-shop-menu');
    scheduleMenuImages(menu);
    let opener = null, bodyStyle = null, top = 0, pendingClose = 0;
    let inerted = [];
    const focusables = () => [...menu.querySelectorAll('a[href],button,summary,[tabindex="0"]')]
      .filter(el => !el.disabled && el.getClientRects().length > 0);
    function finishClose() {
      clearTimeout(pendingClose);
      if (!menu.classList.contains('is-open')) menu.hidden = true;
    }
    function setOpen(open, restoreFocus = true) {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen === open) return;
      clearTimeout(pendingClose);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      if (open) {
        hydrateMenuImages(menu);
        opener = document.activeElement;
        top = window.scrollY;
        bodyStyle = { position: document.body.style.position, top: document.body.style.top,
          width: document.body.style.width, overflow: document.body.style.overflow };
        Object.assign(document.body.style, { position: 'fixed', top: `-${top}px`, width: '100%', overflow: 'hidden' });
        inerted = [...document.body.children].filter(el => !el.contains(header) && !['SCRIPT','STYLE'].includes(el.tagName))
          .map(el => ({el, inert: el.inert}));
        inerted.forEach(({el}) => { el.inert = true; });
        menu.hidden = false;
        backdrop.hidden = false;
        menu.inert = false;
        menu.getBoundingClientRect();
        menu.classList.add('is-open');
        menu.querySelector('.unc-menu-close').focus({preventScroll:true});
      } else {
        menu.classList.remove('is-open');
        menu.inert = true;
        backdrop.hidden = true;
        if (bodyStyle) Object.assign(document.body.style, bodyStyle);
        inerted.forEach(({el, inert}) => { el.inert = inert; });
        inerted = [];
        window.scrollTo({top, behavior: 'instant'});
        if (restoreFocus && opener?.isConnected) opener.focus({preventScroll:true});
        pendingClose = setTimeout(finishClose, 260);
      }
    }
    closeActive = () => setOpen(false);
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.querySelector('.unc-menu-close').addEventListener('click', () => setOpen(false));
    backdrop.addEventListener('click', () => setOpen(false));
    menu.addEventListener('transitionend', event => { if (event.target === menu) finishClose(); });
    menu.addEventListener('click', event => { if (event.target.closest('a[href]')) setOpen(false, false); });
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
        else if (desktop.open) { desktop.open = false; desktop.querySelector('summary').focus(); }
      }
      if (event.key !== 'Tab' || toggle.getAttribute('aria-expanded') !== 'true') return;
      const items = focusables(), first = items[0], last = items.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('click', event => {
      if (desktop.open && !desktop.contains(event.target)) desktop.open = false;
    });
    header.addEventListener('focusout', () => {
      setTimeout(() => { if (!desktop.contains(document.activeElement)) desktop.open = false; }, 0);
    });
    const onSize = () => {
      if (!mobile.matches && toggle.getAttribute('aria-expanded') === 'true') setOpen(false, false);
      if (mobile.matches) desktop.open = false;
    };
    if (mobile.addEventListener) mobile.addEventListener('change', onSize);
    else mobile.addListener(onSize);
  }
  document.addEventListener('shopify:section:unload', () => closeActive());
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => closeActive());
  window.UnchemedNavigation = {init, version:'2026-09-26.2'};
  init();
})();
